import { createAction } from 'redux-actions';
import {
  AUTOMATIC_LANDING,
  AUTOMATIC_SELL_TRANSACTION,
  IRA_AUTOMAX_TRANSACTION,
  TransactionTypes,
} from '../../../../settings/settings';
import { callApi, getEndpoint } from '../../../../utils/api';
import {
  EXCHANGE_TRANSACTION,
  COLLEGE_CONTRIBUTE_TRANSACTION,
  COLLEGE_DISTRIBUTE_TRANSACTION,
  COLLEGE_EXCHANGE_TRANSACTION,
  RECURRING_BUY_TRANSACTION,
  RECURRING_BUY_TRANSACTION_EDIT,
  RECURRING_EXCHANGE_TRANSACTION,
  SELL_TRANSACTION,
  ROTH_CONVERSION,
  transactionType,
} from '../../../../utils/transactions-util';
import { BUY_TRANSACTION } from '../../../../settings/settings';
const ALL_FUNDS = 'ALL_FUNDS';

function pivotFundsByTicker(funds) {
  const byTicker = {};
  if (funds === undefined) {
    return {};
  }
  funds.forEach((fund) => (byTicker[fund.ticker] = fund));
  return byTicker;
}

export default function allFunds(
  state = {
    isLoading: false,
    isLoaded: false,
    hasFailed: false,
    error: null,
    funds: [],
    byTicker: {},
    collegeFundsMap: {},
  },
  { payload, type }
) {
  switch (type) {
    case `${ALL_FUNDS}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case `${ALL_FUNDS}_FULFILLED`:
      return Array.isArray(payload.body)
        ? {
            ...state,
            isLoading: false,
            isLoaded: true,
            funds: payload.body,
            byTicker: pivotFundsByTicker(payload.body),
          }
        : {
            ...state,
            isLoading: false,
            isLoaded: true,
            collegeFundsMap: payload.body,
          };
    case `${ALL_FUNDS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        hasFailed: true,
        error: payload,
      };
    default:
      return state;
  }
}

export const getTRPFunds = () => {
  return (dispatch) => {
    let endpoint;
    switch (transactionType()) {
      case BUY_TRANSACTION:
        endpoint = `${getEndpoint(
          'allFunds'
        )}?productType=MutualFund&transactionType=${TransactionTypes.BUY}`;
        break;
      case IRA_AUTOMAX_TRANSACTION:
      case RECURRING_BUY_TRANSACTION:
      case RECURRING_BUY_TRANSACTION_EDIT:
        endpoint = `${getEndpoint(
          'allFunds'
        )}?productType=MutualFund&transactionType=${TransactionTypes.BUY}`;
        break;
      case RECURRING_EXCHANGE_TRANSACTION:
      case AUTOMATIC_LANDING:
      case EXCHANGE_TRANSACTION:
        endpoint = `${getEndpoint(
          'allFunds'
        )}?productType=MutualFund&transactionType=${TransactionTypes.EXCHANGE}`;
        break;
      case AUTOMATIC_SELL_TRANSACTION:
      case SELL_TRANSACTION:
        endpoint = `${getEndpoint(
          'allFunds'
        )}?productType=MutualFund&transactionType=${TransactionTypes.SELL}`;
        break;
      case COLLEGE_CONTRIBUTE_TRANSACTION:
        endpoint = `${getEndpoint(
          'collegeNewFunds'
        )}?productType=CollegeSavings&transactionType=${TransactionTypes.BUY}`;
        break;
      case COLLEGE_DISTRIBUTE_TRANSACTION:
        endpoint = getEndpoint('collegeNewFunds');
        break;
      case COLLEGE_EXCHANGE_TRANSACTION:
        endpoint = `${getEndpoint(
          'collegeNewFunds'
        )}?productType=CollegeSavings&transactionType=${
          TransactionTypes.EXCHANGE
        }`;
        break;
      case ROTH_CONVERSION:
        endpoint = `${getEndpoint(
          'allFunds'
        )}?productType=MutualFund&transactionType=${
          TransactionTypes.ROTH_CONVERSION
        }`;
        break;
      default:
        console.error(
          'Unexpected transaction type for getTRPFunds: ' + transactionType()
        );
        endpoint = `${getEndpoint('allFunds')}?transactionType=${
          TransactionTypes.BUY
        }`;
        return;
    }
    const action = createAction(ALL_FUNDS)(callApi(endpoint));
    dispatch(action);
  };
};
